// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2apus","messages":"Chat_messages__3Vpum","dateDivider":"Chat_dateDivider__1gizi"};